export default __webpack_public_path__ + "static/media/projTrack7.239d3967.png";